import React, { useEffect, useState } from "react";
import { MDBContainer } from "mdbreact";

import Hero from "./Hero";
import HowToHelp from "./HowToHelp";
import AboutUs from "./AboutUs";
import OurPerformance from "./OurPerformance";
import News from "./News";
import Quote from "./Quote";
import Loader from "../../template/Loader";

import api from "../../../services/api";

export default () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async function fetchNewsData() {
      setLoading(true);

      try {
        const { data } = await api.get("/posts?category=1");

        if (data.success) {
          setNewsData(data.posts);
        }
      } catch (error) {
        console.error(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="home">
      <Hero />
      <Quote />
      <AboutUs />
      <MDBContainer>
        <HowToHelp />
      </MDBContainer>
      <OurPerformance />
      {loading ? (
        <Loader />
      ) : (
        <MDBContainer className="mb-5">
          <News data={newsData} />
        </MDBContainer>
      )}
    </div>
  );
};
